import { db } from '@/api/firebase'
import { DBRoute, Route } from '../../models'

const routeConverter: firebase.firestore.FirestoreDataConverter<Route> = {
  toFirestore(route: Route): DBRoute {
    const { id, geometry, loading, ...dbRoute} = route
    return dbRoute
  },
  fromFirestore(snap, options): Route {
    const dbRoute = snap.data(options) as DBRoute
    return {
      ...dbRoute,
      id: snap.id as string,
      saved: true,
      geometry: { legs: [] },
      loading: false
    }
  },
}

const routesRef = db.collection('routes').withConverter(routeConverter)
const routeRef = (routeId: string) => routesRef.doc(routeId)

export {
  routesRef,
  routeRef
}